/* unplugin-vue-components disabled */import script from "./submitList.vue?vue&type=script&setup=true&lang=js"
export * from "./submitList.vue?vue&type=script&setup=true&lang=js"

import "./submitList.vue?vue&type=style&index=0&id=31885f24&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31885f24"]])

export default __exports__